import { render } from "./Global.vue?vue&type=template&id=6cb2e02c&scoped=true"
const script = {}

import "./Global.vue?vue&type=style&index=0&id=6cb2e02c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cb2e02c"

export default script